import { Context, createContext } from 'react';
import { User } from '../types/user_types.ts';

const AzureAuthContext: Context<User> = createContext({} as User);

export default AzureAuthContext;
